﻿{
    "ai-apps": {
        "tenantPromptMenu": "Klientprompt",
        "mcpServersMenu": "MCP-servrar",
        "menu": "App Builder",
        "list": {
            "title": "Appar",
            "name": "Appnamn",
            "createApp": "Skapa ny app",
            "deletedSuccessfully": "Applikation raderad",
            "noAppsFound": "Inga applikationer hittades",
            "noPublishedVersion": "Ingen publicerad version",
            "publishedBy": "av {name}",
            "versionsCount": "• {count} versioner",
            "updatedAt": "Uppdaterad {time}",
            "startApp": "Starta app",
            "runPublishedVersion": "Kör publicerad version",
            "editApp": "Redigera senaste versionen",
            "continueEditingVersion": "Fortsätt redigera v{version}",
            "copyApp": "Kopiera app",
            "copyAppSubtitle": "Skapa en kopia av denna app",
            "deleteApp": "Ta bort app",
            "deleteAppSubtitle": "Ta bort denna app permanent",
            "rowsPerPage": "Rader per sida",
            "showAll": "Alla"
        },
        "nameAndDescription": "Allmänt",
        "buildTitle": "AI-assistent",
        "dropSession": "Förkasta",
        "dropSessionConfirmation": "Är du säker på att du vill ta bort den aktuella byggsessionen och förkasta alla genererade filer och konversationer?",
        "saveSession": "Spara",
        "saveAndContinue": "Spara och fortsätt bygga",
        "saveAndExit": "Spara och avsluta byggläge",
        "applySessionConfirmation": "Är du säker på att du vill spara de aktuella byggsessionsresultaten?",
        "sessionConflict": "En annan användare redigerar för närvarande denna version",
        "sessionConflictDetail": "Endast en användare kan arbeta på en version åt gången. Vänligen försök igen senare.",
        "sessionConflictSuggestion": "Du kan välja en annan version eller vänta tills den aktuella sessionen är klar.",
        "sessionStartError": "Misslyckades med att starta byggsession",
        "undoLastPrompt": "Ångra senaste prompten",
        "undoLastPromptFailed": "Det gick inte att ångra senaste prompten",
        "stopGenerating": "Stoppa genereringen",
        "stopGeneratingFailed": "Det gick inte att stoppa genereringen",
        "cancelled": "Avbruten",
        "undone": "Ångrad",
        "applicationLabels": "Applikationsetiketter",
        "labels": "Etiketter",
        "description": "Beskrivning",
        "deleteConfirmation": "Är du säker på att du vill ta bort följande applikation: {name}",
        "copy": "Kopiera",
        "copyApplication": "Kopiera applikation",
        "copyOfName": "Kopia av {name}",
        "copyFromVersion": "Kopiera från version",
        "applicationCopied": "Applikationen kopierades",
        "selectTables": "Tabeller",
        "name": "Namn",
        "connection": "Anslutning",
        "vinceAi": "Vince AI",
        "usage": "Användning",
        "cost": "Kostnad",
        "costOverview": {
            "title": "Kostnadsöversikt",
            "accumulatedCost": "Ackumulerad kostnad",
            "summary": "Kostnadssammanfattning",
            "cost": "Kostnad",
            "billedCost": "Fakturerad kostnad",
            "estimatedTotal": "Uppskattad totalsumma",
            "sessions": "Sessioner",
            "calls": "API-anrop",
            "tokens": "Tokens",
            "aiModel": "AI-modell",
            "aiModels": "AI-modeller",
            "costByConnection": "Fakturerad kostnad per anslutning",
            "allConnections": "Alla anslutningar",
            "showAll": "Visa alla",
            "selectConnection": "Visa kostnader för {name}",
            "historicalEstimateNote": "Fakturerad kostnad utesluter tidigare användning som registrerades före exakt prissättning. Den uppskattade totalsumman inkluderar denna tidigare användning.",
            "unknownConnection": "Okänd",
            "total": "Totalt",
            "noCostData": "Ingen kostnadsdata är tillgänglig.",
            "loadError": "Kostnadsdata kunde inte läsas in.",
            "description": "Sök i hela användningshistoriken och förfina sedan resultatet efter system eller modell.",
            "searchFilters": "Sökfilter för användning",
            "connection": "Anslutning",
            "user": "Användare",
            "users": "Användare",
            "allUsers": "Alla användare",
            "label": "Etikett",
            "allLabels": "Alla etiketter",
            "range": "Period",
            "granularity": "Detaljnivå",
            "lifetime": "Hela perioden",
            "last7Days": "Senaste 7 dagarna",
            "last30Days": "Senaste 30 dagarna",
            "last90Days": "Senaste 90 dagarna",
            "customRange": "Anpassad…",
            "daily": "Dagligen",
            "weekly": "Veckovis",
            "from": "Från",
            "to": "Till",
            "completeDateRange": "Välj både start- och slutdatum.",
            "invalidDateRange": "Startdatumet måste vara före eller samma som slutdatumet.",
            "vinceAi": "Vince AI",
            "refineResults": "Förfina returnerad användning",
            "system": "System",
            "model": "Modell",
            "availableWithData": "Tillgänglig med data",
            "allSystems": "Alla system",
            "allModels": "Alla modeller",
            "systemsSelected": "{count} system",
            "modelsSelected": "{count} modeller",
            "retry": "Försök igen",
            "loading": "Laddar",
            "noUsageInPeriod": "Ingen användning registrerades under perioden.",
            "noUsage": "Ingen användning har registrerats ännu.",
            "unpricedUsage": "Viss användning saknar pris, så ingen totalsumma visas.",
            "totalTokens": "Totalt antal tokens",
            "sessionsUnavailable": "Sessioner är inte tillgängliga för denna förfining",
            "sessionCount": "{count} sessioner",
            "callCount": "{count} anrop",
            "dailyUsage": "Daglig användning",
            "weeklyUsage": "Veckovis användning",
            "dailyCost": "Daglig kostnad",
            "weeklyCost": "Veckovis kostnad",
            "chartValue": "Diagramvärde",
            "splitBy": "Dela upp efter",
            "viewAs": "Visa som",
            "chart": "Diagram",
            "table": "Tabell",
            "noSeriesData": "Ingen tidsseriedata är tillgänglig för denna användning.",
            "date": "Datum",
            "unpricedChartNote": "Punkter med användning utan pris exkluderar de saknade kostnaderna.",
            "inputTokens": "Input-tokens",
            "outputTokens": "Output-tokens",
            "cacheWriteTokens": "Cache write-tokens",
            "cacheReadTokens": "Cache read-tokens",
            "tokenBreakdown": "Tokenfördelning",
            "unknownSystem": "Okänt system"
        },
        "tenantUsageTitle": "Användning för AI-appar",
        "applicationUsageTitle": "Användning för {name}",
        "versionUsageTitle": "Användning för version {version}",
        "usageLoadError": "Användningsdata kunde inte läsas in.",
        "vinceAiMcpUnsupported": "Vince AI stöder för närvarande inte MCP-serverresurser. Välj en tenant-anslutning eller ta bort MCP-servrarna.",
        "selectWorkflows": "Arbetsflöden",
        "summary": "Sammanfattning",
        "publishedColumn": "Publicerad",
        "stateHeader": "Status",
        "createdBy": "Skapad av",
        "modifiedBy": "Ändrad av",
        "created": "Skapad av {name} den {date}",
        "newApplication": "Skapa ny applikation",
        "customTablesSelected": "{selectedCount} anpassade tabeller valda.",
        "workflowsSelected": "{selectedCount} arbetsflöden valda.",
        "selectMcpServers": "MCP-servrar",
        "mcpServersSelected": "{selectedCount} MCP-servrar valda.",
        "summaryHeader": "Applikationssammanfattning",
        "resourceAliases": "Åsidosätt resursalias",
        "absentResource": "Resursen hittades inte",
        "customAlias": "Alias",
        "state": {
            "DRAFT": "Utkast",
            "PUBLISHED": "Publicerad",
            "ARCHIVED": "Arkiverad"
        },
        "run": "Starta",
        "currentVersion": "Version",
        "publishedVersionTooltip": "Publicerad version - av {name}",
        "createdVersions": "Skapade versioner",
        "backToList": "Tillbaka till listan",
        "back": "Tillbaka",
        "Version": "Version",
        "archive": "Arkivera",
        "publish": "Publicera",
        "selectedVersion": "Vald version",
        "ver": "ver. ",
        "startBuildSession": "Bygg",
        "editVersionInfo": "Anteckningar",
        "createNewVersion": "Skapa ny version",
        "archiveVersion": "Arkivera",
        "resources": "Resurser",
        "viewResources": "Resurser",
        "versionResourcesLabel": "Resurser för ny version",
        "versionRolesLabel": "Roller för ny version",
        "copyVersionRoles": "Kopiera roller från version {versionNumber}",
        "specifyNewRoles": "Skapa nya roller",
        "specifyRolesAssignments": "Tilldela principals från grunden",
        "copyRolesAssignments": "Kopiera rolltilldelningar från version {versionNumber}",
        "specifyNewResources": "Ange nya resurser",
        "versionAssets": "Tillgångar för ny version",
        "copyVersionResources": "Kopiera resurser från version {versionNumber}",
        "copyVersionAssets": "Kopiera tillgångar från version {versionNumber}",
        "generateFromScratch": "Generera från grunden",
        "resourcesNamesAreNotUnique": "Resursnamn måste vara unika",
        "editApplicationInfo": "Redigera info",
        "publishVersion": "Publicera",
        "updateVersionDescription": "Uppdatera beskrivning",
        "editVersionTitle": "Lägg till anteckning",
        "updateVersionNotes": "Uppdatera anteckningar",
        "archiveVersionTitle": "Arkivera version",
        "publishVersionTitle": "Publicera version",
        "setAsDraftVersionTitle": "Konvertera till utkast",
        "newVersion": "Ny version",
        "versionResources": "Resurser tillgängliga för applikation",
        "resourceNaming": "Resursnamn",
        "simpleM3Workflow": "Enkelt M3-arbetsflöde",
        "resourcesUpdated": "Resurser uppdaterades",
        "changelog": "Versionshistorik",
        "changelogTitle": "Applikationsversioner",
        "versionUpdated": "Versionsinformation uppdaterades",
        "versionCreated": "Ny version skapades",
        "isFavourite": "Din favoritapp. Klicka för att ta bort från favoriter",
        "isNotFavourite": "Klicka för att markera som favoritapp",
        "copiedVersionDescription": "Beskrivning för ny version",
        "messageSendFailed": "Kunde inte skicka meddelandet. Vänligen försök igen.",
        "messageError": "Fel",
        "waitingForResponse": "Väntar på svar...",
        "typeYourMessage": "Skriv ditt meddelande...",
        "loadingConversation": "Laddar konversation...",
        "loadingVersionInfo": "Laddar versionsinformation...",
        "maxImagesReached": "Maximalt {max} bilder tillåtna per meddelande",
        "invalidImageType": "Ogiltig bildtyp: {type}. Tillåtna typer: PNG, JPEG, GIF, WebP",
        "imageTooLarge": "Bildstorleken överstiger {max}KB gränsen",
        "imageUploadFailed": "Misslyckades med att ladda upp bild: {filename}",
        "clickBuildToBuild": "Klicka på Bygg för att börja bygga applikation...",
        "unsavedWorkAlert": "Du har osparade ändringar. Tryck på Spara för att spara dina framsteg.",
        "unsavedWorkLeaveMessage": "Du har en aktiv byggsession med osparade ändringar. Om du lämnar sidan kommer dina framsteg att gå förlorade. Är du säker på att du vill fortsätta?",
        "providedAppsCanBeRunDirectly": "Tillhandahållna appar kan köras direkt från listan.",
        "labelsFilterSelected": "etiketter valda",
        "users": "Användare",
        "usersFilterSelected": "användare valda",
        "createdOrEditedBy": "Skapad eller ändrad av",
        "preview": {
            "appBridgeLogs": "Brygglogg {logsCount}",
            "noPreviewAvailable": "Ingen förhandsgranskning tillgänglig",
            "askAiToGenerate": "Inget att visa ännu, lägg till en prompt för att börja bygga",
            "compilationFailed": "Kompilering misslyckades",
            "compiling": "Kompilerar...",
            "loading": "Laddar förhandsgranskning...",
            "loadFailed": "Kunde inte ladda förhandsgranskning",
            "clearLogs": "Rensa loggar",
            "invocationLogs": "App-brygga-loggar"
        },
        "invocationAction": {
            "REQUEST_RECEIVED": "Begäran från app: ",
            "RESPONSE_RETURNED": "Svar till app ",
            "ERROR": "Fel uppstod ",
            "INIT": "Brygga initialiserad"
        },
        "startingApplication": "Startar applikation. Vänligen vänta...",
        "providedSourceUrl": "Index-URL för tillhandahållen app",
        "applicationType": {
            "GENERATED": "Genererad",
            "PROVIDED": "Tillhandahållen"
        },
        "applicationTypeLabel": "Applikationstyp",
        "minimize": "Minimera",
        "toggleFullScreen": "Helskärm",
        "resource": {
            "app": "App",
            "mcpServer": "MCP-server",
            "tenantPrompt": "Klientprompt",
            "mcpToolPermission": "MCP-verktygsbehörighet"
        },
        "seconds": "s",
        "noMessagesYet": "Inga meddelanden ännu",
        "generatedAssets": "Genererade tillgångar",
        "assetsListTitle": "Tillgångslista",
        "selectAsset": "Välj tillgång för att se detaljer",
        "showAssets": "Tillgångar",
        "noStartUrlProvided": "Kan inte bestämma start-URL för applikation",
        "refresh": "Uppdatera",
        "cannotEditInfoOfAppWithBuildSession": "Kan inte redigera versionsinformation med aktiv byggsession",
        "cannotShowOfAppWithBuildSession": "Kan inte visa tillgångar med aktiv byggsession - tillgångar kommer att vara tillgängliga efter att byggsessionen är klar",
        "cannotArchiveVersionWithBuildSession": "Kan inte arkivera version med aktiv byggsession. Applicera eller förkasta aktuell byggsession först",
        "cannotPublishVersionWithBuildSession": "Kan inte publicera version med aktiv byggsession. Applicera eller förkasta aktuell byggsession först",
        "cannotEditResourcesWithBuildSession": "Med aktiv byggsession är det bara möjligt att visa resurser",
        "cannotEditRolesWithBuildSession": "Kan inte redigera in-app-roller med aktiv byggsession. Applicera eller förkasta aktuell byggsession först",
        "tenantPrompt": {
            "title": "Klientprompt",
            "subtitle": "Prompt som automatiskt läggs till som en del av systemprompt till alla konversationer med din AI-assistent."
        },
        "principalType": {
            "USER": "Användare",
            "ROLE": "Roll"
        },
        "selectUsers": "Välj användare",
        "assignments": "In-app rolltilldelningar: ",
        "simulateRoles": "Simulera roller",
        "roleNotAssigned": "Rollen har inga tilldelade principals",
        "addAssignments": "Lägg till tilldelningar",
        "rolesSelected": "{selectedCount} roller valda.",
        "usersSelected": "{selectedCount} användare valda.",
        "selectRoles": "Välj roller",
        "rolesMenu": "In-app roller",
        "rolesListTitle": "Roller",
        "deleteRoleSuccess": "In-app roll raderad",
        "editRole": "Redigera in-app roll",
        "roleName": "Rollnamn/identifierare",
        "roleNameHint": "Försök använda ett kort och beskrivande namn",
        "dangerToChangeRole": "Att ändra rollnamn/identifierare kan bryta befintlig applikation. Ändra om du är säker på att applikationen inte använder denna roll.",
        "deleteRoleConfirmation": "Är du helt säker på att du vill ta bort rollen: {role}? Alla rolltilldelningar kommer också att tas bort och delar av applikationen kan bli oanvändbara utan den.",
        "selectRole": "Välj roll för att se tilldelningar",
        "selectSession": "Välj byggsession för att se prompt",
        "sessionsTitle": "Byggsessioner",
        "noBuildSessions": "Inga slutförda byggsessioner ännu",
        "showBuildPrompt": "Byggprompt",
        "feedbackMenu": "Feedback",
        "feedbackTitle": "Feedback för applikationen",
        "showRead": "Visa lästa",
        "thisVersionOnly": "Endast denna version",
        "noFeedback": "Ingen feedback ännu",
        "markAsRead": "Markera som läst",
        "feedbackMarkedRead": "Feedback markerad som läst",
        "read": "Läst",
        "feedbackSubmitted": "Av {name} den {date}",
        "feedbackComment": "Feedback",
        "feedbackBy": "Inskickad av",
        "feedbackDate": "Datum",
        "feedbackStatus": "Status",
        "mcpServers": {
            "title": "MCP-servrar",
            "create": "Lägg till MCP-server",
            "createTitle": "Lägg till MCP-server",
            "editTitle": "Redigera MCP-server",
            "name": "Namn",
            "nameHint": "Maskinidentifierare som används som anslutningsnamn. Måste matcha tillåten teckenuppsättning.",
            "namePatternError": "Namnet får endast innehålla bokstäver, siffror, understreck och bindestreck (1-128 tecken).",
            "systemPrompt": "Systemprompt",
            "systemPromptHint": "Valfritt promptfragment som beskriver serverns verktyg för app-byggarassistenten.",
            "config": "Konfigurationsmall",
            "configHint": "JSONata/VinceLiveMorph-mall som måste utvärderas till ett objekt {props}. Exempel:",
            "configVariables": "Tillgängliga variabler (direkt och under $context): $authToken, $userId, $email. JSONata-variabler är utan citattecken. url måste vara en icke-tom sträng.",
            "noServersFound": "Inga MCP-servrar konfigurerade ännu",
            "deleteConfirmation": "Är du säker på att du vill radera MCP-servern: {name}?",
            "deleted": "MCP-server raderad",
            "created": "MCP-server skapad",
            "updated": "MCP-server uppdaterad",
            "testConnection": "Testa anslutning",
            "probeReachable": "Servern är nåbar",
            "probeNoTools": "Servern är nåbar, inga verktyg exponerade",
            "probeFailed": "Anslutningen misslyckades"
        },
        "devicePicker": {
            "deleted": "Enhet raderad",
            "DESKTOP": "Skrivbord",
            "TABLET": "Surfplatta",
            "HANDHELD": "Mobil",
            "addCustom": "Lägg till anpassad",
            "customDefault": "Anpassad",
            "responsivePreview": "Responsivt förhandsgranskningsläge",
            "rotate": "Rotera visningsfält"
        },
        "serviceStatus": {
            "minor": "AI-funktioner kan vara något långsammare än vanligt.",
            "major": "AI-funktioner är för närvarande störda — förvänta dig långsamma svar.",
            "critical": "AI-tjänsten är för närvarande otillgänglig."
        }
    }
}
